// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main_layer[data-v-7321df05] {\n    background-image: url('/images/purchases_head.svg');\n    background-repeat: no-repeat;\n    background-size: cover;\n    min-height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
